import { Modal } from '@/components/common/Modal'
import { EditExternalAssetForm } from '@/components/externalAssets/EditExternalAssetForm'
import type { ExternalAsset } from '@/types/externalAsset'

interface EditExternalAssetModalProps {
  open: boolean
  asset: ExternalAsset | null
  onClose: () => void
}

export function EditExternalAssetModal({ open, asset, onClose }: EditExternalAssetModalProps) {
  if (!asset) return null
  return (
    <Modal open={open} onClose={onClose} title={`Asset bearbeiten: ${asset.name}`}>
      <EditExternalAssetForm asset={asset} onSuccess={onClose} />
    </Modal>
  )
}
